import React from "react";

function SoftwarePage(){
    return(<div>

    </div>)
}

export default SoftwarePage